import { gql } from "@apollo/client";

export const SystemTabInfo = gql`
    query SystemTabInfo($id: ID!) {
        system(id: $id) {
            id
            title
            installedBaseNode {
                id
                title
            }
        }
    }
`;
